unit View.Aliado.List;

interface

uses
  System.SysUtils,
  System.Classes,
  WEBLib.Graphics,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, System.Generics.Collections, XData.Web.Client, Auth.Service,
  UConstantes, UHelperServer, System.StrUtils, WEBLib.WebCtrls, UExportacoes,
  UUtils, UWeb.Enum, UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewAliadoList = class(TForm)
    AliadoDataset: TXDataWebDataSet;
    AliadoDatasetId: TIntegerField;
    AliadoDatasetNome_Fantasia: TStringField;
    AliadoDatasetCNPJ: TStringField;
    AliadoDatasetStatus: TIntegerField;
    AliadoDatasetTelefone_Principal: TStringField;
    AliadoDatasetCEP: TStringField;
    AliadoDatasetsincronizar_dados: TBooleanField;
    AliadoDatasetExcluido: TBooleanField;
    AliadoDatasetInclusao: TDateTimeField;
    AliadoDatasetAlteracao: TDateTimeField;
    AliadoDatasetExclusao: TDateTimeField;
    AliadoDatasetCadastro: TDateField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    AliadoDatasetobservacoes: TStringField;
    lbModalTitulo: TLabel;
    div_checkbox_recursos: THTMLDiv;
    btnSalvarRecursos: TButton;
    cbxSincronizarDados: TCheckBox;
    XDataClientRecursos: TXDataWebClient;
    edtAliadoId: TEdit;
    AliadoDatasetcontrole_interno: TStringField;
    AliadoDatasetcidadeufSigla: TXDataWebDatasetField;
    cbbAliadoStatus: TComboBox;
    AliadoDatasetcertificadodata_vencimento: TDateField;
    AliadoDatasetlogo_base64: TStringField;
    btnExportarExcel: TButton;
    AliadoDatasetparceironome: TStringField;
    AliadoDatasetsegmentoNome: TStringField;
    AliadoDatasetcidadeNome: TStringField;
    AliadoDatasetdata_cancelamento: TDateField;
    AliadoDatasettempo_contrato: TStringField;
    tblAtualizacaoStatus: TDBTableControl;
    cdsAtualizacaoStatus: TXDataWebDataSet;
    cdsAtualizacaoStatusaliado_nome: TStringField;
    cdsAtualizacaoStatusaliado_cnpj: TStringField;
    cdsAtualizacaoStatusstatus_atual: TIntegerField;
    cdsAtualizacaoStatusnovo_status: TIntegerField;
    dtsAtualizacaoStatus: TDataSource;
    XDataWebClientAtualizacaoStatus: TXDataWebClient;
    btnAtualizarStatusSuperlogica: TButton;
    btnAtualizarStatusUpdates: TButton;
    AliadoDatasetdata_ping_madrugada: TDateTimeField;
    AliadoDatasetqtde_dias_servidor_ligado: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure cdsUsuariosAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure btnSalvarRecursosClick(Sender: TObject);
    procedure XDataClientRecursosError(Error: TXDataClientError);
    procedure XDataClientRecursosLoad(Response: TXDataClientResponse);
    procedure cbbAliadoStatusChange(Sender: TObject);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure XDataWebClientAtualizacaoStatusError(Error: TXDataClientError);
    procedure XDataWebClientAtualizacaoStatusLoad(Response: TXDataClientResponse);
    [async]
    procedure btnAtualizarStatusSuperlogicaClick(Sender: TObject); async;
    procedure tblAtualizacaoStatusGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblAtualizacaoStatusGetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure cdsAtualizacaoStatusaliado_cnpjGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    [async]
    procedure btnAtualizarStatusUpdatesClick(Sender: TObject); async;
    procedure cdsAtualizacaoStatusaliado_nomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
  private
    const
      FPrefixoCheckBoxRecursos = 'cbx_recurso_';

    var
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure CriarCheckBoxRecursos;
    procedure DesmarcarTodosRecursos;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewAliadoList: TFViewAliadoList;

implementation

uses
  ConnectionModule,
  View.Main;

{$R *.dfm}

{ TFViewAliadoList }

procedure TFViewAliadoList.btnAtualizarStatusSuperlogicaClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa operação?')) then
  begin
    cdsAtualizacaoStatus.Tag := 1;
    TUtils.ChamarDivLoading('Essa operação pode demorar um pouco!');
    XDataWebClientAtualizacaoStatus.RawInvoke('IService.AtualizarStatusPelaSuperLogica', []);
  end;
end;

procedure TFViewAliadoList.btnAtualizarStatusUpdatesClick(Sender: TObject);
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa operação?')) then
  begin
    cdsAtualizacaoStatus.Tag := 1;
    TUtils.ChamarDivLoading;
    XDataWebClientAtualizacaoStatus.RawInvoke('IService.AtualizarStatusUpdatesPeloServidor', []);
  end;
end;

procedure TFViewAliadoList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(AliadoDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewAliadoList.btnSalvarRecursosClick(Sender: TObject);
var
  lElement: TJSHTMLInputElement;
  lRecursosAliado,
  lIdCheckBox: string;
  lIndice : Integer;
  lJson : TJSObject;
begin
  TUtils.ChamarDivLoading;
  lRecursosAliado := '';
  lJson := TJSObject.New;

  for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + IntToStr(lIndice + 1);

    lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

    if Assigned(lElement) and lElement.checked then
      lRecursosAliado := lRecursosAliado + lElement.value + '|';
  end;

  if lRecursosAliado = '' then
    lJson['controle_interno'] := JSValue(null)
  else
    lJson['controle_interno'] := Copy(lRecursosAliado, 1, Length(lRecursosAliado) - 1);

  lJson['sincronizar_dados'] := cbxSincronizarDados.Checked;


  XDataClientRecursos.RawInvoke('IService.HabilitarRecursosAliado', [edtAliadoId.Text, lJson]);
end;

procedure TFViewAliadoList.cbbAliadoStatusChange(Sender: TObject);
var
  lFiltro : string;
begin
  case cbbAliadoStatus.ItemIndex of
    0 : lFiltro := 'status ne 2';
    4 : lFiltro := '';
    else lFiltro := 'status eq ' + cbbAliadoStatus.ItemIndex.ToString;
  end;

  edSearch.Text := EmptyStr;
  cbPageSize.ItemIndex := 0;

  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.FDatasetPlugin.FFilterPadrao := lFiltro;
  FGridPlugin.Load;
end;

procedure TFViewAliadoList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewAliadoList.cdsAtualizacaoStatusaliado_cnpjGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewAliadoList.cdsAtualizacaoStatusaliado_nomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewAliadoList.cdsUsuariosAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  asm
    location.reload();
  end;
end;

class function TFViewAliadoList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewAliadoList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewAliadoList, AElementID, Result, @AfterCreate);
end;

procedure TFViewAliadoList.CriarCheckBoxRecursos;
var
  lDivCriadaHtml,
  lIdCheckBox,
  lIdLabel : string;
  lIndice : Integer;
begin
  for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + IntToStr(lIndice + 1);
    lIdLabel := 'lbl_recurso_' + IntToStr(lIndice + 1);
    lDivCriadaHtml := '<div class="form-check"><input class="form-check-input" '+
    'type="checkbox" value="'+IntToStr(lIndice + 1)+'" id="'+lIdCheckBox+'"/><label class="form-check-label" id="'+
      lIdLabel+'" for="'+lIdCheckBox+'">'+ FRecursosDisponiveis[lIndice]+'</label></div>';

    div_checkbox_recursos.HTML.Add(lDivCriadaHtml);
  end;
end;

procedure TFViewAliadoList.DesmarcarTodosRecursos;
var
  lIdCheckBox : string;
  lIndice : Integer;
  lElement: TJSHTMLInputElement;
begin
  for lIndice := Low(FRecursosDisponiveis) to High(FRecursosDisponiveis) do
  begin
    lIdCheckBox := FPrefixoCheckBoxRecursos + IntToStr(lIndice + 1);

    lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

    if Assigned(lElement) then
      lElement.checked := False;
  end;
end;

procedure TFViewAliadoList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewAliadoList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewAliadoList.tblAtualizacaoStatusGetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if cdsAtualizacaoStatus.Tag = 0 then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblAtualizacaoStatus.Columns[ACol].DataField, ['aliado_nome',
      'aliado_cnpj']) of
      0, 1: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewAliadoList.tblAtualizacaoStatusGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblAtualizacaoStatus.Columns[ACol].DataField, ['status_atual', 'novo_status']) of
      0, 1:
      begin
        case StrToInt(AValue) of
          1 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
          2 : AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
          3 : AValue := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">Suspenso/Congelado</div>';
          4 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Em Desenvolvimento</div>';
          5 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Free</div>';
          6 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Contrato Cancelado</div>';
          7 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Liberada</div>';
          8 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Em Atendindimento</div>';
          9 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Atendimento Concluído</div>';
          10 : AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Entregue</div>';
          else AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Outros</div>';
        end;
      end;
      else AValue := '<strong>'+AValue+'</strong>';
    end;
  end;
end;

procedure TFViewAliadoList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewAliadoList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordNome,
  RecordControleInterno,
  RecordAliadoId,
  RecordBase64 : string;
  RecordSincronizarDados : Boolean;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure RecursosButtonClick(Sender: TObject);
  var
    lRecursosAliado : TArray<string>;
    lIndice : Integer;
    lIdCheckBox : string;
    lElement: TJSHTMLInputElement;
  begin
    DesmarcarTodosRecursos;
    cbxSincronizarDados.Checked := RecordSincronizarDados;

    lRecursosAliado := SplitString(RecordControleInterno, '|');

    for lIndice := Low(lRecursosAliado) to High(lRecursosAliado) do
    begin
      lIdCheckBox := FPrefixoCheckBoxRecursos + lRecursosAliado[lIndice];
      lElement := TJSHTMLInputElement(document.getElementById(lIdCheckBox));

      if Assigned(lElement) then
        lElement.checked := True;
    end;

    lbModalTitulo.Caption := 'Recursos do aliado ' + RecordNome;
    edtAliadoId.Text := RecordAliadoId;
  end;

  [Async]
  procedure ConnectButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO,
      'Tem certeza que deseja conectar no aliado <b>'+RecordNome+'</b>?')) then
    begin
      FViewMain.cdsUsuarios.Edit;
      FViewMain.cdsUsuarios.FieldByName('data_base_id').Value := null;
      FViewMain.cdsUsuarios.FieldByName('aliado_id').AsInteger := toInteger(RecordId);
      FViewMain.cdsUsuarios.Post;
      FViewMain.cdsUsuarios.ApplyUpdates;
    end;
  end;

var
  Button: TButton;
  lImagem : TImageControl;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'AÇÕES' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      AliadoDataset.Connection.Model.DefaultSchema.FindEntityType(AliadoDataset.EntitySetName),
      AliadoDataset.CurrentData
    );

    RecordAliadoId := AliadoDataset.FieldByName('Id').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver dados');
    Button.ElementHandle.setAttribute('data-test', 'btn_ver_aliado');

    if not(TUtils.IsPerfilAliado(TUtils.FUsuario)) then
    begin
      RecordNome := AliadoDataset.FieldByName('nome_fantasia').AsString;

      Button := TButton.Create(nil);
      Button.Caption := '<i class="fas fa-plug"></i>';
      Button.OnClick := @ConnectButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ParentElement := AElement.element;
      Button.WidthStyle := TSizeStyle.ssAuto;
      Button.HeightStyle := TSizeStyle.ssAuto;
      Button.ElementHandle.style.setProperty('padding', '10px');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Conectar-se ao aliado');
      Button.ElementHandle.setAttribute('data-test', 'btn_conectar_aliado');
    end;

    if TUtils.IsPerfilFacilSistemas(TUtils.FUsuario) then
    begin
      RecordControleInterno := AliadoDataset.FieldByName('controle_interno').AsString;
      RecordSincronizarDados := AliadoDataset.FieldByName('sincronizar_dados').AsBoolean;

      Button := TButton.Create(nil);
      Button.Caption := '<i class="fas fa-cog"></i>';
      Button.OnClick := @RecursosButtonClick;
      Button.ElementClassName := 'btn btn-link btn-black btn-lg';
      Button.ParentElement := AElement.element;
      Button.WidthStyle := TSizeStyle.ssAuto;
      Button.HeightStyle := TSizeStyle.ssAuto;
      Button.ElementHandle.style.setProperty('padding', '10px');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Recursos do aliado');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'modal');
      Button.ElementHandle.setAttribute('data-bs-target', '#modal_recursos');
      Button.ElementHandle.setAttribute('data-test', 'btn_recursos_modal');
    end;

  end
  else if WebDBTableControl1.Columns[ACol].Title = 'Logomarca' then
  begin
    RecordBase64 := AliadoDataset.FieldByName('logo_base64').AsString;

    lImagem := TImageControl.Create(nil);
    lImagem.ParentElement := AElement.element;
    lImagem.Width := 25;
    lImagem.Height := 25;
    lImagem.AutoSize := False;

    if (RecordBase64 = '') then
      lImagem.url := 'assets/img/sem_logo.png'
    else
      lImagem.url := 'data:image/webp;base64,' + RecordBase64;
  end;
end;

procedure TFViewAliadoList.WebFormCreate(Sender: TObject);
var
  lIndexColunaAcoes,
  lIndexColunaObservacoes : Integer;
begin
  if (TUtils.IsPerfilAliado(TUtils.FUsuario)) then
  begin
    lIndexColunaObservacoes := TUtils.GetIndexColunaPeloTitulo(WebDBTableControl1, 'Observações');
    WebDBTableControl1.Columns.Delete(lIndexColunaObservacoes);
  end;

  if not TUtils.IsPerfilFacilSistemas(TUtils.FUsuario, True) then
  begin
    TUtils.RemoverElementoPorId(btnAtualizarStatusSuperlogica.ElementID);
    TUtils.RemoverElementoPorId(btnAtualizarStatusUpdates.ElementID);
  end;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('aliado', 'active');
  TUtils.SetPaginaSelecionada;

  lIndexColunaAcoes := TUtils.GetIndexColunaPeloTitulo(WebDBTableControl1, 'ações');

  case TUtils.FUsuario.Perfil of
    Ord(TPerfil.FACIL_SISTEMAS) :
    begin
      CriarCheckBoxRecursos;
      WebDBTableControl1.Columns[lIndexColunaAcoes].Width := 150;
    end;
    Ord(TPerfil.PARCEIRO) : WebDBTableControl1.Columns[lIndexColunaAcoes].Width := 100;
    Ord(TPerfil.ALIADO) : WebDBTableControl1.Columns[lIndexColunaAcoes].Width := 50;
  end;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, AliadoDataset, lcPaginator,
    lbPaginationInfo);

  if THelperServer.FFilterParametro <> '' then
  begin
    FGridPlugin.FDatasetPlugin.FParametroPersonalizado := 'filtro_personalizado=' + THelperServer.FFilterParametro;
    THelperServer.FFilterParametro := '';
  end;

  if THelperServer.FQuery <> '' then
  begin
    if THelperServer.FQuery = 'status eq 1' then
      cbbAliadoStatus.ItemIndex := 1
    else if THelperServer.FQuery = 'status eq 3' then
      cbbAliadoStatus.ItemIndex := 3
    else
      cbbAliadoStatus.ItemIndex := -1;

    FGridPlugin.FDatasetPlugin.FFilterPadrao := THelperServer.FQuery;
    THelperServer.FQuery := '';
  end
  else
  begin
    if not(TUtils.IsPerfilAliado(TUtils.FUsuario)) then
    begin
      cbbAliadoStatus.ItemIndex := 0;
      FGridPlugin.FDatasetPlugin.FFilterPadrao := 'status ne 2';
    end
    else
    begin
      cbbAliadoStatus.Visible := False;
      THelperServer.RemoverElementoPorId('aliado_status');
    end;
  end;

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewAliadoList.WebFormShow(Sender: TObject);
begin
  if not TUtils.PossuiPermissao('aliado', TTipoPermissao.ALTERAR) then
  begin
    TUtils.RemoverElementoPorId(btnSalvarRecursos.ElementID);
    TUtils.BloquearCamposDiv('divCamposModalRecursos');
  end;
end;

procedure TFViewAliadoList.XDataClientRecursosError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Erro ao atualizar recursos!' + sLineBreak +
    Error.ErrorMessage);
end;

procedure TFViewAliadoList.XDataClientRecursosLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Recursos atualizados com sucesso!');

  asm
    $('#modal_recursos').modal('hide');
  end;

  FGridPlugin.Load;
end;

procedure TFViewAliadoList.XDataWebClientAtualizacaoStatusError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Erro ao realizar atualização!' + sLineBreak +
    Error.ErrorMessage);
end;

procedure TFViewAliadoList.XDataWebClientAtualizacaoStatusLoad(
  Response: TXDataClientResponse);
var
  lJsonArray: TJSArray;
  lIndice : Integer;
  lJsonObject : TJSObject;
begin
  cdsAtualizacaoStatus.Close;
  cdsAtualizacaoStatus.Open;

  lJsonArray := Response.ResultAsArray;

  if lJsonArray.Length = 0 then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Todos os aliados já estavam com status atualizado!')
  else
  begin
    for lIndice := 0 to lJsonArray.Length - 1 do
    begin
      lJsonObject := TJSObject(lJsonArray[lIndice]);
      cdsAtualizacaoStatus.Append;
      cdsAtualizacaoStatus.FieldByName('aliado_nome').AsString := string(lJsonObject['aliado_nome']);
      cdsAtualizacaoStatus.FieldByName('aliado_cnpj').AsString := string(lJsonObject['aliado_cnpj']);
      cdsAtualizacaoStatus.FieldByName('status_atual').AsInteger := Integer(lJsonObject['status_atual']);
      cdsAtualizacaoStatus.FieldByName('novo_status').AsInteger := Integer(lJsonObject['novo_status']);
      cdsAtualizacaoStatus.Post;
    end;

    FGridPlugin.Load;
    TUtils.OpenModal('modal_superlogica');
  end;
end;

procedure TFViewAliadoList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
var
  lUf : string;
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['observacoes', 'Status', 'sincronizar_dados',
      'Excluido', 'CNPJ', 'CEP', 'Telefone_Principal', 'cidade.Nome', 'certificado.data_vencimento']) of
      0:
      begin
        if Length(AValue) > 100 then
          AValue := Copy(AValue, 1, 100) + '...';
      end;
      1:
      begin
        case StrToInt(AValue) of
          1 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
          2 : AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
          else  AValue := '<div class="rounded-pill" style="background-color: #1E90FF;color:white; padding-right: 5px;padding-left: 5px;">Suspenso/Congelado</div>';
        end;
      end;
      2, 3:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      4: AValue := TUtils.FormatarCnpj_Cpf(AValue);
      5: AValue := TUtils.FormatarCEP(AValue);
      6: AValue := TUtils.FormatarTelefone(AValue);
      7:
      begin
        AValue := THelperServer.GetValueOrEmpty(AValue);
        lUf := AliadoDataset.FieldByName('cidade.uf.Sigla').AsString;

        if not(AValue.IsEmpty) and not lUf.IsEmpty then
          AValue := AValue + ' - ' + lUf;
      end;
      8:
      begin
        if UpperCase(AValue) = 'NULL' then
          AValue := ''
        else if AValue <> '' then
        begin
          if StrToDate(AValue) < Date then
            AValue := '<span class="text-danger"><strong>'+AValue+'</strong></span>'
          else
            AValue := '<span class="text-success"><strong>'+AValue+'</strong></span>'
        end;
      end
      else
      begin
        if UpperCase(AValue) = 'NULL' then
          AValue := '';
      end;
    end;
  end;
end;

procedure TFViewAliadoList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['Nome_Fantasia',
      'observacoes', 'segmento.Nome', 'parceiro.nome', 'cidade.Nome', 'tempo_contrato']) of
      0, 1, 2, 3, 4, 5: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewAliadoList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.aliado.list.pagination.info');
  lbModalTitulo := TLabel.Create('modal_recursos_label');
  WebDBTableControl1 := TDBTableControl.Create('view.aliado.list.table');
  cbPageSize := TComboBox.Create('view.aliado.list.cbPageSize');
  edSearch := TEdit.Create('view.aliado.list.search');
  lcPaginator := TListControl.Create('view.aliado.list.pagination');
  div_checkbox_recursos := THTMLDiv.Create('div_checkbox_recursos');
  btnSalvarRecursos := TButton.Create('btn_salvar_recursos');
  cbxSincronizarDados := TCheckBox.Create('cbx_sincronizar_dados');
  edtAliadoId := TEdit.Create('edt_aliado_id');
  cbbAliadoStatus := TComboBox.Create('aliado_status');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  tblAtualizacaoStatus := TDBTableControl.Create('tblAtualizacaoSuperlogica');
  btnAtualizarStatusSuperlogica := TButton.Create('btnAtualizarStatusSuperlogica');
  btnAtualizarStatusUpdates := TButton.Create('btnAtualizarStatusUpdates');
  AliadoDataset := TXDataWebDataSet.Create(Self);
  AliadoDatasetId := TIntegerField.Create(Self);
  AliadoDatasetNome_Fantasia := TStringField.Create(Self);
  AliadoDatasetCNPJ := TStringField.Create(Self);
  AliadoDatasetStatus := TIntegerField.Create(Self);
  AliadoDatasetTelefone_Principal := TStringField.Create(Self);
  AliadoDatasetCEP := TStringField.Create(Self);
  AliadoDatasetsincronizar_dados := TBooleanField.Create(Self);
  AliadoDatasetExcluido := TBooleanField.Create(Self);
  AliadoDatasetInclusao := TDateTimeField.Create(Self);
  AliadoDatasetAlteracao := TDateTimeField.Create(Self);
  AliadoDatasetExclusao := TDateTimeField.Create(Self);
  AliadoDatasetCadastro := TDateField.Create(Self);
  AliadoDatasetdata_cancelamento := TDateField.Create(Self);
  AliadoDatasettempo_contrato := TStringField.Create(Self);
  AliadoDatasetcontrole_interno := TStringField.Create(Self);
  AliadoDatasetparceironome := TStringField.Create(Self);
  AliadoDatasetsegmentoNome := TStringField.Create(Self);
  AliadoDatasetcidadeNome := TStringField.Create(Self);
  AliadoDatasetcidadeufSigla := TXDataWebDatasetField.Create(Self);
  AliadoDatasetcertificadodata_vencimento := TDateField.Create(Self);
  AliadoDatasetdata_ping_madrugada := TDateTimeField.Create(Self);
  AliadoDatasetqtde_dias_servidor_ligado := TIntegerField.Create(Self);
  AliadoDatasetlogo_base64 := TStringField.Create(Self);
  AliadoDatasetobservacoes := TStringField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataClientRecursos := TXDataWebClient.Create(Self);
  cdsAtualizacaoStatus := TXDataWebDataSet.Create(Self);
  cdsAtualizacaoStatusaliado_nome := TStringField.Create(Self);
  cdsAtualizacaoStatusaliado_cnpj := TStringField.Create(Self);
  cdsAtualizacaoStatusstatus_atual := TIntegerField.Create(Self);
  cdsAtualizacaoStatusnovo_status := TIntegerField.Create(Self);
  dtsAtualizacaoStatus := TDataSource.Create(Self);
  XDataWebClientAtualizacaoStatus := TXDataWebClient.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  lbModalTitulo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  div_checkbox_recursos.BeforeLoadDFMValues;
  btnSalvarRecursos.BeforeLoadDFMValues;
  cbxSincronizarDados.BeforeLoadDFMValues;
  edtAliadoId.BeforeLoadDFMValues;
  cbbAliadoStatus.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  tblAtualizacaoStatus.BeforeLoadDFMValues;
  btnAtualizarStatusSuperlogica.BeforeLoadDFMValues;
  btnAtualizarStatusUpdates.BeforeLoadDFMValues;
  AliadoDataset.BeforeLoadDFMValues;
  AliadoDatasetId.BeforeLoadDFMValues;
  AliadoDatasetNome_Fantasia.BeforeLoadDFMValues;
  AliadoDatasetCNPJ.BeforeLoadDFMValues;
  AliadoDatasetStatus.BeforeLoadDFMValues;
  AliadoDatasetTelefone_Principal.BeforeLoadDFMValues;
  AliadoDatasetCEP.BeforeLoadDFMValues;
  AliadoDatasetsincronizar_dados.BeforeLoadDFMValues;
  AliadoDatasetExcluido.BeforeLoadDFMValues;
  AliadoDatasetInclusao.BeforeLoadDFMValues;
  AliadoDatasetAlteracao.BeforeLoadDFMValues;
  AliadoDatasetExclusao.BeforeLoadDFMValues;
  AliadoDatasetCadastro.BeforeLoadDFMValues;
  AliadoDatasetdata_cancelamento.BeforeLoadDFMValues;
  AliadoDatasettempo_contrato.BeforeLoadDFMValues;
  AliadoDatasetcontrole_interno.BeforeLoadDFMValues;
  AliadoDatasetparceironome.BeforeLoadDFMValues;
  AliadoDatasetsegmentoNome.BeforeLoadDFMValues;
  AliadoDatasetcidadeNome.BeforeLoadDFMValues;
  AliadoDatasetcidadeufSigla.BeforeLoadDFMValues;
  AliadoDatasetcertificadodata_vencimento.BeforeLoadDFMValues;
  AliadoDatasetdata_ping_madrugada.BeforeLoadDFMValues;
  AliadoDatasetqtde_dias_servidor_ligado.BeforeLoadDFMValues;
  AliadoDatasetlogo_base64.BeforeLoadDFMValues;
  AliadoDatasetobservacoes.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataClientRecursos.BeforeLoadDFMValues;
  cdsAtualizacaoStatus.BeforeLoadDFMValues;
  cdsAtualizacaoStatusaliado_nome.BeforeLoadDFMValues;
  cdsAtualizacaoStatusaliado_cnpj.BeforeLoadDFMValues;
  cdsAtualizacaoStatusstatus_atual.BeforeLoadDFMValues;
  cdsAtualizacaoStatusnovo_status.BeforeLoadDFMValues;
  dtsAtualizacaoStatus.BeforeLoadDFMValues;
  XDataWebClientAtualizacaoStatus.BeforeLoadDFMValues;
  try
    Name := 'FViewAliadoList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    lbModalTitulo.SetParentComponent(Self);
    lbModalTitulo.Name := 'lbModalTitulo';
    lbModalTitulo.Left := 8;
    lbModalTitulo.Top := 397;
    lbModalTitulo.Width := 62;
    lbModalTitulo.Height := 13;
    lbModalTitulo.Caption := 'lbModalTitulo';
    lbModalTitulo.HeightPercent := 100.000000000000000000;
    lbModalTitulo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 337;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#199#213'ES';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Logomarca';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Nome_Fantasia';
      Title := 'Nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'CNPJ';
      Title := 'Cnpj';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Status';
      Title := 'Status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'segmento.Nome';
      Title := 'Segmento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Telefone_Principal';
      Title := 'Telefone';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cidade.Nome';
      Title := 'Cidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'CEP';
      Title := 'Cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'certificado.data_vencimento';
      Title := 'Certificado Venc.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sincronizar_dados';
      Title := 'Sincronizar Dados';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Cadastro';
      Title := 'Cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_cancelamento';
      Title := 'Data Cancel.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tempo_contrato';
      Title := 'Tempo Contrato';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'parceiro.nome';
      Title := 'Parceiro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacoes';
      Title := 'Observa'#231#245'es';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_ping_madrugada';
      Title := 'Ping Serv. Madrugada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'qtde_dias_servidor_ligado';
      Title := 'Dias Serv. Ligado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'Exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 224;
    edSearch.Top := 59;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 105;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    div_checkbox_recursos.SetParentComponent(Self);
    div_checkbox_recursos.Name := 'div_checkbox_recursos';
    div_checkbox_recursos.Left := 8;
    div_checkbox_recursos.Top := 416;
    div_checkbox_recursos.Width := 100;
    div_checkbox_recursos.Height := 41;
    div_checkbox_recursos.ChildOrder := 7;
    div_checkbox_recursos.Role := '';
    btnSalvarRecursos.SetParentComponent(Self);
    btnSalvarRecursos.Name := 'btnSalvarRecursos';
    btnSalvarRecursos.Left := 8;
    btnSalvarRecursos.Top := 463;
    btnSalvarRecursos.Width := 96;
    btnSalvarRecursos.Height := 25;
    btnSalvarRecursos.Caption := 'Salvar';
    btnSalvarRecursos.ChildOrder := 8;
    btnSalvarRecursos.HeightPercent := 100.000000000000000000;
    btnSalvarRecursos.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarRecursos, Self, 'OnClick', 'btnSalvarRecursosClick');
    cbxSincronizarDados.SetParentComponent(Self);
    cbxSincronizarDados.Name := 'cbxSincronizarDados';
    cbxSincronizarDados.Left := 128;
    cbxSincronizarDados.Top := 465;
    cbxSincronizarDados.Width := 121;
    cbxSincronizarDados.Height := 22;
    cbxSincronizarDados.Caption := 'Sincronizar Dados?';
    cbxSincronizarDados.ChildOrder := 9;
    cbxSincronizarDados.HeightPercent := 100.000000000000000000;
    cbxSincronizarDados.WidthPercent := 100.000000000000000000;
    edtAliadoId.SetParentComponent(Self);
    edtAliadoId.Name := 'edtAliadoId';
    edtAliadoId.Left := 128;
    edtAliadoId.Top := 416;
    edtAliadoId.Width := 121;
    edtAliadoId.Height := 22;
    edtAliadoId.ChildOrder := 10;
    edtAliadoId.Enabled := False;
    edtAliadoId.HeightPercent := 100.000000000000000000;
    edtAliadoId.Visible := False;
    edtAliadoId.WidthPercent := 100.000000000000000000;
    cbbAliadoStatus.SetParentComponent(Self);
    cbbAliadoStatus.Name := 'cbbAliadoStatus';
    cbbAliadoStatus.Left := 255;
    cbbAliadoStatus.Top := 416;
    cbbAliadoStatus.Width := 90;
    cbbAliadoStatus.Height := 21;
    cbbAliadoStatus.HeightPercent := 100.000000000000000000;
    cbbAliadoStatus.TabStop := False;
    cbbAliadoStatus.Text := '<> INATIVO';
    cbbAliadoStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbAliadoStatus, Self, 'OnChange', 'cbbAliadoStatusChange');
    cbbAliadoStatus.ItemIndex := 0;
    cbbAliadoStatus.Items.BeginUpdate;
    try
      cbbAliadoStatus.Items.Clear;
      cbbAliadoStatus.Items.Add('<> INATIVO');
      cbbAliadoStatus.Items.Add('ATIVO');
      cbbAliadoStatus.Items.Add('INATIVO');
      cbbAliadoStatus.Items.Add('SUSP. / CONGELADO');
      cbbAliadoStatus.Items.Add('TODOS');
    finally
      cbbAliadoStatus.Items.EndUpdate;
    end;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 255;
    btnExportarExcel.Top := 463;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    tblAtualizacaoStatus.SetParentComponent(Self);
    tblAtualizacaoStatus.Name := 'tblAtualizacaoStatus';
    tblAtualizacaoStatus.Left := 382;
    tblAtualizacaoStatus.Top := 94;
    tblAtualizacaoStatus.Width := 299;
    tblAtualizacaoStatus.Height := 155;
    tblAtualizacaoStatus.ElementClassName := 'table-responsive';
    tblAtualizacaoStatus.BorderColor := clSilver;
    tblAtualizacaoStatus.ChildOrder := 19;
    tblAtualizacaoStatus.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblAtualizacaoStatus, Self, 'OnGetCellData', 'tblAtualizacaoStatusGetCellData');
    SetEvent(tblAtualizacaoStatus, Self, 'OnGetCellClass', 'tblAtualizacaoStatusGetCellClass');
    tblAtualizacaoStatus.Columns.Clear;
    with tblAtualizacaoStatus.Columns.Add do
    begin
      DataField := 'aliado_nome';
      Title := 'NOME';
    end;
    with tblAtualizacaoStatus.Columns.Add do
    begin
      ElementClassName := 'fw-bolder';
      DataField := 'aliado_cnpj';
      Title := 'CNPJ';
    end;
    with tblAtualizacaoStatus.Columns.Add do
    begin
      DataField := 'status_atual';
      Title := 'STATUS ANTIGO';
    end;
    with tblAtualizacaoStatus.Columns.Add do
    begin
      DataField := 'novo_status';
      Title := 'NOVO STATUS';
    end;
    tblAtualizacaoStatus.DataSource := dtsAtualizacaoStatus;
    btnAtualizarStatusSuperlogica.SetParentComponent(Self);
    btnAtualizarStatusSuperlogica.Name := 'btnAtualizarStatusSuperlogica';
    btnAtualizarStatusSuperlogica.Left := 375;
    btnAtualizarStatusSuperlogica.Top := 463;
    btnAtualizarStatusSuperlogica.Width := 122;
    btnAtualizarStatusSuperlogica.Height := 25;
    btnAtualizarStatusSuperlogica.Caption := 'Atualizar Status SuperL'#243'gica';
    btnAtualizarStatusSuperlogica.ChildOrder := 11;
    btnAtualizarStatusSuperlogica.HeightPercent := 100.000000000000000000;
    btnAtualizarStatusSuperlogica.WidthPercent := 100.000000000000000000;
    SetEvent(btnAtualizarStatusSuperlogica, Self, 'OnClick', 'btnAtualizarStatusSuperlogicaClick');
    btnAtualizarStatusUpdates.SetParentComponent(Self);
    btnAtualizarStatusUpdates.Name := 'btnAtualizarStatusUpdates';
    btnAtualizarStatusUpdates.Left := 511;
    btnAtualizarStatusUpdates.Top := 463;
    btnAtualizarStatusUpdates.Width := 122;
    btnAtualizarStatusUpdates.Height := 25;
    btnAtualizarStatusUpdates.Caption := 'Atualizar Status Updates';
    btnAtualizarStatusUpdates.ChildOrder := 11;
    btnAtualizarStatusUpdates.HeightPercent := 100.000000000000000000;
    btnAtualizarStatusUpdates.WidthPercent := 100.000000000000000000;
    SetEvent(btnAtualizarStatusUpdates, Self, 'OnClick', 'btnAtualizarStatusUpdatesClick');
    AliadoDataset.SetParentComponent(Self);
    AliadoDataset.Name := 'AliadoDataset';
    AliadoDataset.EntitySetName := 'Aliado';
    AliadoDataset.Connection := DMConnection.ApiConnection;
    AliadoDataset.Left := 72;
    AliadoDataset.Top := 144;
    AliadoDatasetId.SetParentComponent(AliadoDataset);
    AliadoDatasetId.Name := 'AliadoDatasetId';
    AliadoDatasetId.FieldName := 'Id';
    AliadoDatasetId.Required := True;
    AliadoDatasetNome_Fantasia.SetParentComponent(AliadoDataset);
    AliadoDatasetNome_Fantasia.Name := 'AliadoDatasetNome_Fantasia';
    AliadoDatasetNome_Fantasia.FieldName := 'Nome_Fantasia';
    AliadoDatasetNome_Fantasia.Required := True;
    AliadoDatasetNome_Fantasia.Size := 255;
    AliadoDatasetCNPJ.SetParentComponent(AliadoDataset);
    AliadoDatasetCNPJ.Name := 'AliadoDatasetCNPJ';
    AliadoDatasetCNPJ.FieldName := 'CNPJ';
    AliadoDatasetCNPJ.Required := True;
    AliadoDatasetCNPJ.Size := 255;
    AliadoDatasetStatus.SetParentComponent(AliadoDataset);
    AliadoDatasetStatus.Name := 'AliadoDatasetStatus';
    AliadoDatasetStatus.FieldName := 'Status';
    AliadoDatasetStatus.Required := True;
    AliadoDatasetTelefone_Principal.SetParentComponent(AliadoDataset);
    AliadoDatasetTelefone_Principal.Name := 'AliadoDatasetTelefone_Principal';
    AliadoDatasetTelefone_Principal.FieldName := 'Telefone_Principal';
    AliadoDatasetTelefone_Principal.Size := 255;
    AliadoDatasetCEP.SetParentComponent(AliadoDataset);
    AliadoDatasetCEP.Name := 'AliadoDatasetCEP';
    AliadoDatasetCEP.FieldName := 'CEP';
    AliadoDatasetCEP.Size := 255;
    AliadoDatasetsincronizar_dados.SetParentComponent(AliadoDataset);
    AliadoDatasetsincronizar_dados.Name := 'AliadoDatasetsincronizar_dados';
    AliadoDatasetsincronizar_dados.FieldName := 'sincronizar_dados';
    AliadoDatasetExcluido.SetParentComponent(AliadoDataset);
    AliadoDatasetExcluido.Name := 'AliadoDatasetExcluido';
    AliadoDatasetExcluido.FieldName := 'Excluido';
    AliadoDatasetExcluido.Required := True;
    AliadoDatasetInclusao.SetParentComponent(AliadoDataset);
    AliadoDatasetInclusao.Name := 'AliadoDatasetInclusao';
    AliadoDatasetInclusao.FieldName := 'Inclusao';
    AliadoDatasetInclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    AliadoDatasetAlteracao.SetParentComponent(AliadoDataset);
    AliadoDatasetAlteracao.Name := 'AliadoDatasetAlteracao';
    AliadoDatasetAlteracao.FieldName := 'Alteracao';
    AliadoDatasetAlteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    AliadoDatasetExclusao.SetParentComponent(AliadoDataset);
    AliadoDatasetExclusao.Name := 'AliadoDatasetExclusao';
    AliadoDatasetExclusao.FieldName := 'Exclusao';
    AliadoDatasetExclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    AliadoDatasetCadastro.SetParentComponent(AliadoDataset);
    AliadoDatasetCadastro.Name := 'AliadoDatasetCadastro';
    AliadoDatasetCadastro.FieldName := 'Cadastro';
    AliadoDatasetCadastro.DisplayFormat := 'dd/mm/yyyy';
    AliadoDatasetdata_cancelamento.SetParentComponent(AliadoDataset);
    AliadoDatasetdata_cancelamento.Name := 'AliadoDatasetdata_cancelamento';
    AliadoDatasetdata_cancelamento.FieldName := 'data_cancelamento';
    AliadoDatasetdata_cancelamento.DisplayFormat := 'dd/mm/yyyy';
    AliadoDatasettempo_contrato.SetParentComponent(AliadoDataset);
    AliadoDatasettempo_contrato.Name := 'AliadoDatasettempo_contrato';
    AliadoDatasettempo_contrato.Tag := 3;
    AliadoDatasettempo_contrato.FieldName := 'tempo_contrato';
    AliadoDatasettempo_contrato.Size := 255;
    AliadoDatasetcontrole_interno.SetParentComponent(AliadoDataset);
    AliadoDatasetcontrole_interno.Name := 'AliadoDatasetcontrole_interno';
    AliadoDatasetcontrole_interno.FieldName := 'controle_interno';
    AliadoDatasetcontrole_interno.Size := 255;
    AliadoDatasetparceironome.SetParentComponent(AliadoDataset);
    AliadoDatasetparceironome.Name := 'AliadoDatasetparceironome';
    AliadoDatasetparceironome.FieldName := 'parceiro.nome';
    AliadoDatasetsegmentoNome.SetParentComponent(AliadoDataset);
    AliadoDatasetsegmentoNome.Name := 'AliadoDatasetsegmentoNome';
    AliadoDatasetsegmentoNome.FieldKind := fkCalculated;
    AliadoDatasetsegmentoNome.FieldName := 'segmento.Nome';
    AliadoDatasetsegmentoNome.Calculated := True;
    AliadoDatasetcidadeNome.SetParentComponent(AliadoDataset);
    AliadoDatasetcidadeNome.Name := 'AliadoDatasetcidadeNome';
    AliadoDatasetcidadeNome.FieldName := 'cidade.Nome';
    AliadoDatasetcidadeufSigla.SetParentComponent(AliadoDataset);
    AliadoDatasetcidadeufSigla.Name := 'AliadoDatasetcidadeufSigla';
    AliadoDatasetcidadeufSigla.FieldKind := fkCalculated;
    AliadoDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    AliadoDatasetcidadeufSigla.Calculated := True;
    AliadoDatasetcertificadodata_vencimento.SetParentComponent(AliadoDataset);
    AliadoDatasetcertificadodata_vencimento.Name := 'AliadoDatasetcertificadodata_vencimento';
    AliadoDatasetcertificadodata_vencimento.FieldKind := fkCalculated;
    AliadoDatasetcertificadodata_vencimento.FieldName := 'certificado.data_vencimento';
    AliadoDatasetcertificadodata_vencimento.DisplayFormat := 'dd/mm/yyyy';
    AliadoDatasetcertificadodata_vencimento.Calculated := True;
    AliadoDatasetdata_ping_madrugada.SetParentComponent(AliadoDataset);
    AliadoDatasetdata_ping_madrugada.Name := 'AliadoDatasetdata_ping_madrugada';
    AliadoDatasetdata_ping_madrugada.FieldName := 'data_ping_madrugada';
    AliadoDatasetdata_ping_madrugada.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    AliadoDatasetqtde_dias_servidor_ligado.SetParentComponent(AliadoDataset);
    AliadoDatasetqtde_dias_servidor_ligado.Name := 'AliadoDatasetqtde_dias_servidor_ligado';
    AliadoDatasetqtde_dias_servidor_ligado.FieldName := 'qtde_dias_servidor_ligado';
    AliadoDatasetlogo_base64.SetParentComponent(AliadoDataset);
    AliadoDatasetlogo_base64.Name := 'AliadoDatasetlogo_base64';
    AliadoDatasetlogo_base64.Tag := 2;
    AliadoDatasetlogo_base64.FieldName := 'logo_base64';
    AliadoDatasetlogo_base64.Size := 255;
    AliadoDatasetobservacoes.SetParentComponent(AliadoDataset);
    AliadoDatasetobservacoes.Name := 'AliadoDatasetobservacoes';
    AliadoDatasetobservacoes.Tag := 2;
    AliadoDatasetobservacoes.FieldName := 'observacoes';
    AliadoDatasetobservacoes.Size := 255;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := AliadoDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 200;
    tmrConsulta.Top := 168;
    XDataClientRecursos.SetParentComponent(Self);
    XDataClientRecursos.Name := 'XDataClientRecursos';
    XDataClientRecursos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRecursos, Self, 'OnLoad', 'XDataClientRecursosLoad');
    SetEvent(XDataClientRecursos, Self, 'OnError', 'XDataClientRecursosError');
    XDataClientRecursos.Left := 144;
    XDataClientRecursos.Top := 16;
    cdsAtualizacaoStatus.SetParentComponent(Self);
    cdsAtualizacaoStatus.Name := 'cdsAtualizacaoStatus';
    cdsAtualizacaoStatus.Left := 448;
    cdsAtualizacaoStatus.Top := 163;
    cdsAtualizacaoStatusaliado_nome.SetParentComponent(cdsAtualizacaoStatus);
    cdsAtualizacaoStatusaliado_nome.Name := 'cdsAtualizacaoStatusaliado_nome';
    cdsAtualizacaoStatusaliado_nome.FieldName := 'aliado_nome';
    SetEvent(cdsAtualizacaoStatusaliado_nome, Self, 'OnGetText', 'cdsAtualizacaoStatusaliado_nomeGetText');
    cdsAtualizacaoStatusaliado_cnpj.SetParentComponent(cdsAtualizacaoStatus);
    cdsAtualizacaoStatusaliado_cnpj.Name := 'cdsAtualizacaoStatusaliado_cnpj';
    cdsAtualizacaoStatusaliado_cnpj.FieldName := 'aliado_cnpj';
    SetEvent(cdsAtualizacaoStatusaliado_cnpj, Self, 'OnGetText', 'cdsAtualizacaoStatusaliado_cnpjGetText');
    cdsAtualizacaoStatusstatus_atual.SetParentComponent(cdsAtualizacaoStatus);
    cdsAtualizacaoStatusstatus_atual.Name := 'cdsAtualizacaoStatusstatus_atual';
    cdsAtualizacaoStatusstatus_atual.FieldName := 'status_atual';
    cdsAtualizacaoStatusnovo_status.SetParentComponent(cdsAtualizacaoStatus);
    cdsAtualizacaoStatusnovo_status.Name := 'cdsAtualizacaoStatusnovo_status';
    cdsAtualizacaoStatusnovo_status.FieldName := 'novo_status';
    dtsAtualizacaoStatus.SetParentComponent(Self);
    dtsAtualizacaoStatus.Name := 'dtsAtualizacaoStatus';
    dtsAtualizacaoStatus.DataSet := cdsAtualizacaoStatus;
    dtsAtualizacaoStatus.Left := 544;
    dtsAtualizacaoStatus.Top := 163;
    XDataWebClientAtualizacaoStatus.SetParentComponent(Self);
    XDataWebClientAtualizacaoStatus.Name := 'XDataWebClientAtualizacaoStatus';
    XDataWebClientAtualizacaoStatus.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientAtualizacaoStatus, Self, 'OnLoad', 'XDataWebClientAtualizacaoStatusLoad');
    SetEvent(XDataWebClientAtualizacaoStatus, Self, 'OnError', 'XDataWebClientAtualizacaoStatusError');
    XDataWebClientAtualizacaoStatus.Left := 590;
    XDataWebClientAtualizacaoStatus.Top := 131;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    lbModalTitulo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    div_checkbox_recursos.AfterLoadDFMValues;
    btnSalvarRecursos.AfterLoadDFMValues;
    cbxSincronizarDados.AfterLoadDFMValues;
    edtAliadoId.AfterLoadDFMValues;
    cbbAliadoStatus.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    tblAtualizacaoStatus.AfterLoadDFMValues;
    btnAtualizarStatusSuperlogica.AfterLoadDFMValues;
    btnAtualizarStatusUpdates.AfterLoadDFMValues;
    AliadoDataset.AfterLoadDFMValues;
    AliadoDatasetId.AfterLoadDFMValues;
    AliadoDatasetNome_Fantasia.AfterLoadDFMValues;
    AliadoDatasetCNPJ.AfterLoadDFMValues;
    AliadoDatasetStatus.AfterLoadDFMValues;
    AliadoDatasetTelefone_Principal.AfterLoadDFMValues;
    AliadoDatasetCEP.AfterLoadDFMValues;
    AliadoDatasetsincronizar_dados.AfterLoadDFMValues;
    AliadoDatasetExcluido.AfterLoadDFMValues;
    AliadoDatasetInclusao.AfterLoadDFMValues;
    AliadoDatasetAlteracao.AfterLoadDFMValues;
    AliadoDatasetExclusao.AfterLoadDFMValues;
    AliadoDatasetCadastro.AfterLoadDFMValues;
    AliadoDatasetdata_cancelamento.AfterLoadDFMValues;
    AliadoDatasettempo_contrato.AfterLoadDFMValues;
    AliadoDatasetcontrole_interno.AfterLoadDFMValues;
    AliadoDatasetparceironome.AfterLoadDFMValues;
    AliadoDatasetsegmentoNome.AfterLoadDFMValues;
    AliadoDatasetcidadeNome.AfterLoadDFMValues;
    AliadoDatasetcidadeufSigla.AfterLoadDFMValues;
    AliadoDatasetcertificadodata_vencimento.AfterLoadDFMValues;
    AliadoDatasetdata_ping_madrugada.AfterLoadDFMValues;
    AliadoDatasetqtde_dias_servidor_ligado.AfterLoadDFMValues;
    AliadoDatasetlogo_base64.AfterLoadDFMValues;
    AliadoDatasetobservacoes.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataClientRecursos.AfterLoadDFMValues;
    cdsAtualizacaoStatus.AfterLoadDFMValues;
    cdsAtualizacaoStatusaliado_nome.AfterLoadDFMValues;
    cdsAtualizacaoStatusaliado_cnpj.AfterLoadDFMValues;
    cdsAtualizacaoStatusstatus_atual.AfterLoadDFMValues;
    cdsAtualizacaoStatusnovo_status.AfterLoadDFMValues;
    dtsAtualizacaoStatus.AfterLoadDFMValues;
    XDataWebClientAtualizacaoStatus.AfterLoadDFMValues;
  end;
end;

end.
